import React, { useEffect, useState } from 'react';
import Navbar from '../Navbar';
import { Link, useNavigate } from 'react-router-dom';
import {Box, Button,Grid, Hidden, TextField, Typography} from '@mui/material';
import swal from 'sweetalert';
import axios from 'axios';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';
import _ from "lodash";
import Swal from 'sweetalert2';
import BootstrapTable from 'react-bootstrap-table-next';
import 'bootstrap/dist/css/bootstrap.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';

import filterFactory,{textFilter, selectFilter} from 'react-bootstrap-table2-filter';
import overlayFactory from 'react-bootstrap-table2-overlay';
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from '@mui/material/styles';
import { Stack } from '@mui/material';

function ShowList() {
  const [loading, setLoading] = useState(true);
  const [listmonth, setlistmonth] = useState([true]);

  useEffect(()=>{
      axios.get(`api/show_listmonth`).then(res=>{
          if(res.status === 200){
            setlistmonth(res.data.listmonth);
          }
          setLoading(false);
      });
  },[]);

  
   
  

   
    // const values = listmonth.map((item) => {
    //   return ( 
    //    item.is_closed===1?
    //    "close"
    //    :"open"
    //   )
    // });
   

  const deleteUser = (e, id) => {

    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const data= {user_id:userId,};
    const thisClicked = e.currentTarget;
   // let userId = localStorage.getItem("auth_id");
    //console.log(userId);
   
        const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: true
    })
        
        swalWithBootstrapButtons.fire({
          title: 'Are you sure , you want to delete this Details',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes,delete it!',
          confirmButtonColor: "#D10000",
          cancelButtonColor:"#00D100",
          cancelButtonText: 'No, cancel!',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {
    

            axios.post(`api/delete_listmonth/${id}`,data).then(res=>{
              if(res.data.status === 200){
            thisClicked.closest("tr").remove();
          }
          else if(res.data.status===404){
            swal("Success",res.data.message,"success");
            thisClicked.innerText = "Delete";
      
          }
         });
            swalWithBootstrapButtons.fire(
              
              'Deleted!',
              'Month deleted successfully.',
              'success'
            )
          } else if (
            
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
          }
        })
    
      }

      const { palette } = createTheme();
      const { augmentColor } = palette;
      const createColor = (mainColor) => augmentColor({ color: { main: mainColor } });
      const theme = createTheme({
        palette: {
          anger: createColor('#F40B27'),
          apple: createColor('#A38A00'),
          steelBlue: createColor('#5C76B7'),
          violet: createColor('#BC00A3'),
        },
        button: { // Here is where you can customise the button
          fontSize: 16,
          fontWeight: 1700,
        }, 
      });
  
  
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      . Showing {from} to {to} of {size} Results"
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "5",
        value: 5,
      },
      {
        text: "10",
        value: 10,
      },
      {
        text: "All",
        value: listmonth.length,
      },
  
    ], // A numeric array is also available. the purpose of above example is custom the text
  };
 
const columns = [
  {
    dataField: "id",
    text: "ID",
  },
  {
    dataField: "month_name",
    text: "month_name",
  },
  {
    dataField: "year",
    text: "year",
  },
  {
    dataField:"month_status",
    text: "is_closed",
    
  },
  
  {
    dataField: 'action',
    text: 'Actions',
    formatter:  (cell, row, rowIndex, formatExtraData) => { 
      const listmonth_id= row.id;
      const monthstatus = row.is_closed;
      return (
        <ThemeProvider theme={theme}>
        <Grid container spacing={2}>
        <Grid item xs={3}>

        <Button component={Link} to={`/certificates/view_listmonth/${listmonth_id}`} color="apple" size="medium" startIcon={<VisibilityIcon color='inherit'/>}/>
          </Grid>
           <Grid item xs={3}>
          <Button  component={Link} to={`/certificates/edit_listmonth/${listmonth_id}`} color="apple" size="medium" startIcon={<EditIcon color='inherit'/>} disabled={monthstatus == 1}/>
          </Grid>
          <Grid item xs={3}>
          <Button onClick={(e) => deleteUser(e, listmonth_id)}  color="primary" size="medium" startIcon={<DeleteIcon color='error'/>} disabled={monthstatus == 1}/>
          </Grid>
           </Grid>
           </ThemeProvider>
      )
    },
  },
];


return (
  <div>
    <Navbar/>
    <div className = "card px-8 m-5">
      <div className = "card-header">
      <div class="d-flex justify-content-between">
           <h4>List Month Details
           </h4>
           <ThemeProvider theme={theme}>
           <Button component={Link} to="/certificates/add_listmonth" variant='contained' color='apple'>Add month</Button>
           </ThemeProvider>
      </div>
      </div>
      <BootstrapTable keyField='id' data={listmonth} columns={columns} hover condensed
        // pagination={paginationFactory(options)}
        filter={filterFactory()}
        overlay={ overlayFactory() }  
    />
  </div>
  </div>
  
)
}


export default ShowList


